import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

const SearchIcon = (props: SvgIconProps) => {
    return (
        <SvgIcon viewBox="0 0 25 25" {...props}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M7.3472 7.53437C9.69035 5.19122 13.4893 5.19122 15.8325 7.53437C18.1756 9.87751 18.1756 13.6765 15.8325 16.0196C13.4893 18.3628 9.69035 18.3628 7.3472 16.0196C5.00406 13.6765 5.00406 9.87751 7.3472 7.53437ZM5.93299 6.12015C9.05718 2.99596 14.1225 2.99596 17.2467 6.12015C20.1314 9.00488 20.3525 13.5446 17.91 16.683L21.297 20.0699C21.6875 20.4604 21.6875 21.0936 21.297 21.4841C20.9064 21.8746 20.2733 21.8746 19.8827 21.4841L16.4958 18.0972C13.3574 20.5397 8.81772 20.3186 5.93299 17.4339C2.80879 14.3097 2.80879 9.24435 5.93299 6.12015Z"
            />
        </SvgIcon>
    );
};

export default SearchIcon;
